import { twMerge } from 'tailwind-merge';

type FilterHeadingProps = {
  title?: string;
  icon: string;
  iconRotation?: 'up' | 'down';
  variant?: 'green' | 'blue' | 'default';
  onClick: () => void;
};

export const FilterHeading = ({ title, variant = 'blue', icon, iconRotation, onClick }: FilterHeadingProps) => {
  const getTextColor = () => {
    switch (variant) {
      case 'green':
        return 'tw-text-[#20AA67]';
      case 'blue':
        return 'tw-text-[#2D5EFF]';
      case 'default':
        return 'tw-text-[#4E4E4E]';
    }
  };

  const getIconRotation = () => {
    switch (iconRotation) {
      case 'up':
        return '[transform:rotate(180deg)]';
      case 'down':
        return '[transform:rotate(0deg)]';
    }
    return '';
  };

  const iconAlignment = title ? 'tw-justify-between' : 'tw-justify-end';

  return (
    <button
      type="button"
      className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-border-none tw-bg-transparent tw-outline-none"
      onClick={onClick}
    >
      <div className={twMerge('tw-flex tw-w-full tw-items-center', iconAlignment)}>
        {title && (
          <span
            className={twMerge(
              'tw-font-jost tw-text-[20px] tw-font-semibold tw-uppercase tw-leading-[25px]',
              getTextColor()
            )}
          >
            {title}
          </span>
        )}
        <div className="tw-flex tw-h-[40px] tw-w-[40px] tw-items-center tw-justify-center">
          <img src={icon} alt="Reset filters" className={twMerge('tw-h-[16px] tw-w-[16px]', getIconRotation())} />
        </div>
      </div>
    </button>
  );
};
